import React, { ReactElement } from 'react'
import StatusIcon from 'ui/atoms/StatusIcon/StatusIcon'

export type PublishRocketStatus = 'active' | 'warning' | 'danger' | 'inactive'

const statusToVariant = {
  inactive: 'regular_wip_inactive',
  active: 'regular_wip_published',
  danger: 'regular_wip_failed',
  warning: 'regular_wip_warning',
} as const

type PublishRocketIconProps = {
  status: PublishRocketStatus
  size?: 'small' | 'medium' | 'large'
}

export default function PublishRocketIcon({
  status = 'active',
  size = 'medium',
}: PublishRocketIconProps): ReactElement {
  return <StatusIcon variant={statusToVariant[status]} size={size} />
}
